import Api from "./api"

const subscribe = async(email) => {
  let payload = {email}
  let response = await Api.post('newslettersubscribe', payload)
  return response
}

export default {
  subscribe
}